export default __webpack_public_path__ + "static/B0116-68df70c1431d27be2cb86c0bec507ebb.png";